import React from 'react';
import ContactForm from "./ContactForm";
import GoogleMapStyle from "./GoogleMapStyle";
import { FiHeadphones, FiMail, FiMapPin } from "react-icons/fi";

const ContactOne = () => {
    return (
        <>
            <div className="row row--15">
                <div className="col-lg-12">
                    <div className="rn-contact-address mt_dec--30">
                        <div className="row" role="list">
                            <div className="col-lg-4 col-md-6 col-12" role="listitem">
                                <div className="rn-address">
                                    <div className="icon" aria-hidden="true">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Call us today</h4>
                                        <p><a href="tel:+441216551122" aria-label="Call us at +44 121 655 1122">+44 121 655 1122</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12" role="listitem">
                                <div className="rn-address">
                                    <div className="icon" aria-hidden="true">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Send an Email</h4>
                                        <p><a href="mailto:contact@whatson.agency" aria-label="Email us at contact@whatson.agency">contact@whatson.agency</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12" role="listitem">
                                <div className="rn-address">
                                    <div className="icon" aria-hidden="true">
                                        <FiMapPin />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Visit our Office</h4>
                                        <p>13a Cannon St, Birmingham B2 5EN, UK</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt--40 row--15">
                <div className="col-lg-7" role="region" aria-label="Contact form">
                    <ContactForm formStyle="contact-form-1" />
                </div>
                <div className="col-lg-5 mt_md--30 mt_sm--30" role="region" aria-label="Google map location">
                    <GoogleMapStyle />
                </div>
            </div>
        </>
    )
}
export default ContactOne;